export default (state) => state.app.csrfToken;
